import React from 'react';

// Scripture images for each page
export const SCRIPTURE_HEADERS = {
  about: {
    url: 'https://static.prod-images.emergentagent.com/jobs/d5b6a475-12ed-4057-ae9d-2a4f013301cd/images/6d22e9238029ee5c04ead75e6cdfc143b7586df1aa81f1b879d491fc6c20a576.png',
    alt: 'For where two or three gather in my name, there am I with them. Matthew 18:20'
  },
  sermons: {
    url: 'https://static.prod-images.emergentagent.com/jobs/d5b6a475-12ed-4057-ae9d-2a4f013301cd/images/00aa6fd77ee1b098543c81c4ac7fc6781470b155c686b875f7a2672f98af38cc.png',
    alt: 'Your word is a lamp for my feet, a light on my path. Psalm 119:105'
  },
  podcast: {
    url: 'https://static.prod-images.emergentagent.com/jobs/d5b6a475-12ed-4057-ae9d-2a4f013301cd/images/bd631873bc8b4f5b0df5ea2c4f5b427b64b519bcee5747e45234e3946c9a6083.png',
    alt: 'Be still and know that I am God. Psalm 46:10'
  },
  programs: {
    url: 'https://static.prod-images.emergentagent.com/jobs/d5b6a475-12ed-4057-ae9d-2a4f013301cd/images/39cf1ba393428d4e8332ffdbe7e093271746e078a16afd46a64a4ba9889a8dcf.png',
    alt: 'Each of you should use whatever gift you have received to serve others. 1 Peter 4:10'
  },
  events: {
    url: 'https://static.prod-images.emergentagent.com/jobs/d5b6a475-12ed-4057-ae9d-2a4f013301cd/images/398ba489fa1ccf02e41b8e95f9672a35e9d2fbc8774bf9550f02e7d10060bba4.png',
    alt: 'Let us not give up meeting together. Hebrews 10:25'
  },
  smallGroups: {
    url: 'https://static.prod-images.emergentagent.com/jobs/d5b6a475-12ed-4057-ae9d-2a4f013301cd/images/0608242d6baa634f1239529b8298ba027ea390308376b220a28f1e8868ce27e8.png',
    alt: 'And let us consider how we may spur one another on toward love and good deeds. Hebrews 10:24'
  },
  pantries: {
    url: 'https://static.prod-images.emergentagent.com/jobs/d5b6a475-12ed-4057-ae9d-2a4f013301cd/images/3d6f4ab093f2015e463eb34db7a37f590138fb7b58c4b27ecf7ed18952792a74.png',
    alt: 'For I was hungry and you gave me something to eat. Matthew 25:35'
  },
  kids: {
    url: 'https://static.prod-images.emergentagent.com/jobs/d5b6a475-12ed-4057-ae9d-2a4f013301cd/images/e37f50804abd973b9d15a1a3da2ca709717feae764bc3f1fd4545fc57e231853.png',
    alt: 'Train up a child in the way he should go. Proverbs 22:6'
  },
  prayer: {
    url: 'https://static.prod-images.emergentagent.com/jobs/d5b6a475-12ed-4057-ae9d-2a4f013301cd/images/982cf8021460a5c19e3a77e167b933e8a7a8e2bec8cb368e962cb4276251ba3a.png',
    alt: 'Do not be anxious about anything, but in every situation, by prayer present your requests to God. Philippians 4:6'
  },
  donate: {
    url: 'https://static.prod-images.emergentagent.com/jobs/d5b6a475-12ed-4057-ae9d-2a4f013301cd/images/bacf36e551a95ee87aeec24dbcf697d0fd6505747093b26c3468b0ce3cf5ebcc.png',
    alt: 'Each of you should give what you have decided in your heart to give. 2 Corinthians 9:7'
  },
  partners: {
    url: 'https://static.prod-images.emergentagent.com/jobs/d5b6a475-12ed-4057-ae9d-2a4f013301cd/images/8339d6b61e3338b3b1ede691e9b17f01f31f8cda85900cdf8984dbce4e90621c.png',
    alt: 'The Lord God took the man and put him in the Garden of Eden to work it and take care of it. Genesis 2:15'
  }
};

export default function ScriptureHeader({ page }) {
  const scripture = SCRIPTURE_HEADERS[page];
  
  if (!scripture) return null;
  
  return (
    <div 
      style={{ 
        width: '100%', 
        position: 'relative',
        aspectRatio: '16/9',
        overflow: 'hidden'
      }}
    >
      <img 
        src={scripture.url} 
        alt={scripture.alt}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center 35%',
          display: 'block'
        }}
      />
    </div>
  );
}
